<div class="bgImg">
  <div class="overlay p-3 p-md-5 container-fluid text-center">
    <h2 class="titles">لماذا مصر</h2>
    <p class="subTitle">
      يتمتع المستثمرون في مصر بعائدات مرتفعة، إلى جانب الدعم المُقَدَم من
      قطاعٍ ماليٍ قوي، والنظرة الإيجابية للنمو الاقتصادي، فضلًا عن دعمهم من
      قِبَل قيادةٍ قويةِ ملتزمة بالإصلاح والتحول الاقتصادي.
    </p>
  </div>

  <div class="container-fluid pb-3 pb-md-5 imagesRow">
    <div class="row g-3 g-md-4 justify-content-center">
      <div *ngFor="let img of images; let i = index" 
           class="col-12 col-sm-6 col-lg-4"
           [ngClass]="{'col-lg-5': i === 0}">
        <div class="imgWrapper" [ngClass]="{'largeImg': i === 0}">
          <img [src]="img" alt="Why Egypt" class="whyImg" />
        </div>
      </div>
    </div>
  </div>

  <div class="text-center pb-4">
    <button class="btnGreen">إقرأ المزيد</button>
  </div>
</div>